///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import {
	globalLoadingActionCreators,
	errorManagerActionCreators,
	toastSuccessActionCreators,
	initKioskCreationAddPricesActionCreators,
} from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'
import { uriList } from '../../routings/settings/RouteList'

const postKioskAddPrices = function* ({ payload }) {
	const bodyMessage = payload.filters
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_KIOSK_ADD_PRICES(payload.requestId, payload.queryParams)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMessage)

		yield put(initKioskCreationAddPricesActionCreators.postKioskAddPricesSuccess(data.data, payload.requestId))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationAddPricesActionCreators.postKioskAddPricesFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}
const putUpdatePrices = function* ({ payload }) {
	const bodyMessage = payload.newPrice
	const user = yield select(selectIdsUser)
	const apiCall = R.PUT_UPDATE_PRICES(payload.requestId, payload.action)
	const MsgParams = 'toast__initKiosk__price_modified'
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, bodyMessage)

		yield put(initKioskCreationAddPricesActionCreators.putUpdatePricesSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationAddPricesActionCreators.putUpdatePricesFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}
const putValidatePrices = function* ({ payload }) {
	const bodyMessage = payload.newPrice
	const user = yield select(selectIdsUser)
	const apiCall = R.PUT_VALIDATE_PRICES(payload.requestId)
	const redirectRequest =
		payload.redirectTest === 'customer'
			? `${uriList.initKiosks}${uriList.initKioskCustomerManager}${uriList.kioskSummary}/${payload.requestId}`
			: `${uriList.initKiosks}${uriList.initKioskBusinessManager}${uriList.kioskSummary}/${payload.requestId}`
	const MsgParams = 'toast__initKiosk__price_defined'
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, bodyMessage)

		yield put(initKioskCreationAddPricesActionCreators.putValidatePricesSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams, redirectRequest))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationAddPricesActionCreators.putValidatePricesFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.POST_KIOSK_ADD_PRICES, postKioskAddPrices)
	yield takeLatest(ActionsTypes.PUT_UPDATE_PRICES, putUpdatePrices)
	yield takeLatest(ActionsTypes.PUT_VALIDATE_PRICES, putValidatePrices)
}

export default sagas
